import { Modal, ModalBody, ModalHeader, ModalFooter } from "react-bootstrap"
import React from "react"
import { SearchSelect } from "./search_select"
import { useCopyCustomerCourseMutation, useGetCustomerCoursesQuery, useGetCustomersQuery } from "../api/courses"
import { useState } from "react"
import { showNotification, showErrorNotification } from "../../shared/helpers"
import GlgInlineLoadingSpinner from "../../shared/components/glg_loading_spinner_inline"

export const CopyCourseModal = ({show, setShow}) => {

  const [searchQuery, setSearchQuery] = useState()
  const [selectedCustomer, setSelectedCustomer] = useState()
  const [selectedCourse, setSelectedCourse] = useState()
  const {data: options, isLoading: optionsLoading} = useGetCustomersQuery({q: searchQuery}, {skip: !show || !searchQuery})
  const {data: importableCourses, isLoading: importableCoursesLoading} = useGetCustomerCoursesQuery({customer: selectedCustomer}, {skip: !show || !selectedCustomer})
  const [copyCourse] = useCopyCustomerCourseMutation()

  const handleSearchChange = (value) => {
    setSearchQuery(value)
  }

  const handleSelectChange = (value) => {
    setSelectedCustomer(value)
  }

  const handleCourseSelect = (event) => {
    setSelectedCourse(event.target.value)
  }

  const handleSave = async () => {
    try {
      await copyCourse({ incoming_course_id: selectedCourse, incoming_customer_id: selectedCustomer }).unwrap();
      setShow(false);
      showNotification('Course copied successfully')
      window.location.reload()
    } catch (error) {
      showErrorNotification("Failed to copy the course")
    }
  };

  const CoursesDropdown = () => {
    if(importableCoursesLoading)
      return <GlgInlineLoadingSpinner className='add-margin-top-10'></GlgInlineLoadingSpinner>

    if(importableCourses && importableCourses.length == 0)
      return <div className="add-margin-top-10">{window.I18n.t('courses.copy_course_modal.no_importable_courses')}</div>

    if(importableCourses)
      return(
        <div className="add-margin-top-10 courses_box">
          <label className="bold">{window.I18n.t('courses.copy_course_modal.courses')}</label>
          <select 
            className="add-margin-left-10" 
            onChange={handleCourseSelect}
            value={selectedCourse || ""}
          >
            <option value="" disabled>{window.I18n.t('courses.copy_course_modal.select_course')}</option>
            {
              importableCourses.map((course) => (
                <option key={course.value} value={course.value}>
                  {course.label}
                </option>
              ))
            }
          </select>
        </div>
      )

    return null
  }
  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size='sm'
        className="center-modal"
        backdrop='static'>
          <div className="courses-modal-title-container">
            <div className="courses-modal-title">
            {window.I18n.t('courses.copy_course_modal.copy_course_from_customer')}
            </div>
          </div>
           <ModalBody className="courses-small-modal-body-container">
              <div className="add-margin-top-10">
                <SearchSelect 
                  placeholder='Search for a Customer'
                  handleSearchChange={handleSearchChange}
                  handleSelectChange={handleSelectChange}
                  options={options}
                  isLoading={optionsLoading}/>
              </div>
              <CoursesDropdown/>
              <div className="btsp_notices add-margin-top-20">
                {window.I18n.t('courses.copy_course_modal.copy_course_notice')}
              </div>
            </ModalBody>
            <ModalFooter>
              <div className="courses-modal-buttons-container">
                <button onClick={() => setShow(false)} className="cancel_action small grey button btsp_small_white_button">
                  {window.I18n.t('courses.cancel')}
                </button>
                <button onClick={handleSave} className="next_action small orange button btsp_small_orange_button">
                  {window.I18n.t('courses.copy_course_modal.copy_in')}
                </button>
              </div>
            </ModalFooter>
      </Modal>
    </>
  )
}